import React, {useEffect, useState, useRef} from 'react'
import { Helmet } from 'react-helmet'
import Sidebar from '../components/sidebar'
import './account.css'
import {get_account, get_screen, rescan_qr, update_config} from "../apis/index"
import {toast} from "react-toastify"

const Account = (props) => {
  const [account, setAccount] = useState({config: {dialogflow_credentials: {name: 'steve'}}})
  const [screen_url, set_Screen_url] = useState("/external/loading.png")

  const account_id_ref = useRef(null);
  const api_key_ref = useRef(null);


  const handleFileUpload = async (event) => {
    const file = event.target.files[0];

    if (file.type !== 'application/json') {
      console.error('Invalid file format. Only JSON files are allowed.');
      return;
    }

    // Read the file content
    const fileContent = await readFileContent(file);

    try {
      const jsonData = JSON.parse(fileContent);
      update_config(account.account_id, JSON.stringify({"dialogflow_credentials": jsonData}))
    } catch (error) {
      console.error('Error parsing JSON file:', error);
      toast.error(error.message)
    }
  };
  

  const readFileContent = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const content = reader.result;
        resolve(content);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsText(file);
    });
  };


  useEffect(() => {
    const queryParams = new URLSearchParams(props.location.search);
    const account_id = queryParams.get('id');
    if(!account_id){
      return props.history.push("/accounts")
    }
    (async () => {
      let response = await get_account(account_id);
      if(response){
        setAccount(response.data)
      }
    })
    ()


    const fetchImage = async () => {
      try {
        const imageUrl = await get_screen(account_id);
        console.log(imageUrl)
        if(imageUrl){
          set_Screen_url(imageUrl)
        }else{
          set_Screen_url("/external/loading.png")
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchImage();

    const interval = setInterval(fetchImage, 5000);

    return () => clearInterval(interval);
  }, []);


  const handleRescanQr = () => {
    rescan_qr(account.account_id)
  }

  const handleCopy = (ref_to_use) => {
    const range = document.createRange();
    range.selectNode(ref_to_use.current);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('copy');
    selection.removeAllRanges();
    toast.success("Copied")
  };

  
  return (
    <div className="account-container">
      <Helmet>
        <title>account - wapi</title>
        <meta property="og:title" content="account - wapi" />
      </Helmet>
      <div className="account-container01">
        <Sidebar rootClassName="sidebar-root-class-name"></Sidebar>
        <div className="account-container02">
          <div className="account-header">
            <div className="account-container03">
              <div className="account-container04">
                <h3>Account</h3>
              </div>
            </div>
          </div>
          <div className="account-body">
            <div className="account-container05">
              <div className="account-accountheader">
                <img
                  alt="image"
                  src="/external/image-lfxe-200w.png"
                  className="account-image"
                />
                <h2 className="account-text01">{account.name}</h2>
                <h3 className="account-text02">({account.phone_number})</h3>
              </div>
              <div className="account-accountbody">
                <div className="account-whatsappinstancecontainer">
                  <div className="account-heading">
                    <div className="account-container06">
                      {/* <button className="account-button button">Refresh</button> */}
                      <button className="account-button1 button" onClick={handleRescanQr}>
                        Rescan QR
                      </button>
                    </div>
                  </div>
                  <div className="account-instance">
                    <img
                      alt="image"
                      src={screen_url}
                      className="account-image1"
                    />
                  </div>
                </div>
                <div className="account-credentialscontainer">
                  <div className="account-container08">
                    <div className="account-container09">
                      <h4 className="account-text04">Api Credentials</h4>
                    </div>
                    <div className="account-container10">
                      <span>account_id</span>
                      <div className="account-container11">
                        <span className="account-text06" ref={account_id_ref}>
                          {account.account_id}
                        </span>
                        <button className="account-button2 button" onClick={() => {
                          handleCopy(account_id_ref)
                        }}>Copy</button>
                      </div>
                    </div>
                    <div className="account-container12">
                      <span>api_key</span>
                      <div className="account-container13">
                        <span className="account-text08" ref={api_key_ref}>
                          {account.config.api_key}
                        </span>
                        <button className="account-button3 button"  onClick={() => {
                          handleCopy(api_key_ref)
                        }}>Copy</button>
                      </div>
                    </div>
                  </div>
                  <div className="account-container14">
                    <div className="account-container15">
                      <div className="account-container16">
                        <h4 className="account-text09">Webhook</h4>
                        <div className="account-container17">
                          <input className="account-text10" placeholder='webhook url' value={account.config.webhook_url} onChange={(e) => {
                            let webhook_url = e.target.value.trim()
                            setAccount({...account, config: {...account.config, webhook_url}})
                          }} />
                          <button className="account-button4 button" onClick={
                            (e) => {
                              e.preventDefault();
                              let webhook_url = account.config.webhook_url.trim()
                              update_config(account.account_id, JSON.stringify({webhook_url}))
                            }
                          }>
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="account-dialogflow">
              <div className="account-container18">
                <h1 className="account-text11">Integration</h1>
              </div>
              <div className="account-head">
                <div className="account-container19">
                  <img
                    alt="image"
                    src="/dialogflow-svgrepo-com.svg"
                    className="account-image2"
                  />
                  <h3 className="account-text12">
                    Google Dialogflow
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </h3>
                </div>
                <div className="account-container20">
                  <svg viewBox="0 0 1024 1024" className="account-icon13">
                    <path d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s0.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-0.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z"></path>
                  </svg>
                  <a href="https://www.youtube.com/watch?v=YVbrBNYp9SQ" target="_blank" >Watch tutorial</a>
                  {/* <span>Watch tutorial</span> */}
                </div>
              </div>
              <div className="account-body1">
                <span className="account-text14">
                  Integrate your WhatsApp with Dialogflow for seamless
                  conversational experiences. Connect the power of
                  Dialogflow&apos;s AI chatbot platform with the convenience and
                  popularity of WhatsApp messaging.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </div>
              <div className="account-buttoncontainer">
                <input style={{display: "none"}} className="credentialupload" type="file" accept=".json" onChange={handleFileUpload} />
               
               {
                  account.config.dialogflow_credentials && Object.keys(account.config.dialogflow_credentials).length > 0 ? (
                    <button className="account-button5 button" style={{display: "flex"}} onClick={(e) => {
                      e.preventDefault()
                      update_config(account.account_id, JSON.stringify({"dialogflow_credentials": {}}))
                      setAccount({...account, config: {...account.config, "dialogflow_credentials": {}}})
                    }}>Disconnect</button>
                  ):(
                    <button className="account-button6 button" onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(".credentialupload").click();
                    }}>
                      Upload Credentials
                    </button>
                  )
               }

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Account
